import { c as _c } from "react/compiler-runtime";
import { Button } from '@systemeio/components';
import { Share03Icon } from '@systemeio/icons';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
interface TemplateCardProps {
  onSelect: () => void | Promise<void>;
  isActive: boolean;
  preview?: {
    href: string;
    alt?: string;
    dataTestId?: string;
  };
  isFetching?: boolean;
  className?: string;
  dataTestId?: string;
  style?: React.CSSProperties;
}
export function TemplateCard(t0) {
  const $ = _c(22);
  const {
    onSelect,
    preview,
    isActive,
    isFetching,
    className,
    children,
    style,
    dataTestId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const t1 = isActive && "border-border-accent";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = twMerge("border-border-100 hover:shadow-1 bg-bg-primary group relative flex h-64 w-56 flex-col items-center justify-start overflow-hidden rounded-xl border", t1, className);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== preview || $[4] !== t) {
    t3 = preview && <Button variant="secondary" size="icon-sm" render={<a onClick={_temp} className="focus-visible:focus-ring-primary group outline-none" href={preview.href} target="_blank" rel="noopener noreferrer" aria-label={preview.alt ?? t("global.view")} data-test-id={preview.dataTestId} />}><Share03Icon /></Button>;
    $[3] = preview;
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = isActive && isFetching;
  let t5;
  if ($[6] !== t) {
    t5 = t("global.use_template");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== dataTestId || $[9] !== isFetching || $[10] !== onSelect || $[11] !== t4 || $[12] !== t5) {
    t6 = <Button onClick={onSelect} variant="secondary" size="sm" disabled={isFetching} isLoading={t4} data-test-id={dataTestId}>{t5}</Button>;
    $[8] = dataTestId;
    $[9] = isFetching;
    $[10] = onSelect;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t6) {
    t7 = <div className="bg-bg-primary desktop:hover-capable:pointer-events-none desktop:hover-capable:opacity-0 desktop:group-hover:pointer-events-auto desktop:group-hover:opacity-100 desktop:group-focus-within:pointer-events-auto desktop:group-focus-within:opacity-100 absolute inset-x-0 bottom-0 z-10 flex justify-end gap-3 px-3 py-2 transition-opacity">{t3}{t6}</div>;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== children || $[18] !== style || $[19] !== t2 || $[20] !== t7) {
    t8 = <div style={style} className={t2}>{children}{t7}</div>;
    $[17] = children;
    $[18] = style;
    $[19] = t2;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}
function _temp(e) {
  return e.stopPropagation();
}